<div class="tax-strategy">
  <div class="row">
    <!-- <div class="medium-1 columns"></div> -->
    <div class="medium-12 columns d-flex align-items-center justify-content-center">
      <div class="medium-3 column roi-filter">
        <app-tpiq-select-dropdown [setData]="filterYears" [includeNone]="false" (onValueSelect)="filterROIPage($event)"
                               [setDefaultValue]="yearFilter" [setSearchKey]="'name'" [setPlaceHolder]="'Year'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
      </div>
      <div class="medium-3 column roi-filter">
        <app-tpiq-select-dropdown [setData]="filteredViews" [includeNone]="false" (onValueSelect)="setView($event)"
                               [setDefaultValue]="currentView" [setSearchKey]="'name'" [setPlaceHolder]="'Select View'" [setValueKey]="'name'"></app-tpiq-select-dropdown>
      </div>
      <div class="medium-3 column roi-filter">
        <app-tpiq-select-dropdown [setData]="scenarios" [includeNone]="false" (onValueSelect)="setScenario($event)"
                               [setDefaultValue]="taxPlanId" [setSearchKey]="'name'" [setPlaceHolder]="'Scenario'" [setValueKey]="'id'"></app-tpiq-select-dropdown>
      </div>
      <!-- <div class="medium-2 column roi-filter">
        <span style="position: relative;top: 10px;">
          <input type="checkbox" [(ngModel)]="displayLogo"/>
          <span style="color: #878787; padding-left: 10px">Display Logo</span>
        </span>
      </div>
      <div class="medium-2 column" style="margin-top: 12px;">
        <div class="icons report-icon-header">
          <i class="icon ion-ios-cloud-download-outline" data-toggle="roi-download"></i>
          <div class="dropdown-pane pdf-export-dropdown" id="roi-download" data-dropdown data-hover="true" data-hover-pane="true" foundation>
            <div (click)="exportToPDF('roi_page')" class="export-option">Export into pdf</div>
            <div (click)="exportToExcel('roi_page')" class="export-option">Export into excel</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
  <div class="row">
    <div *ngIf="hasROIData" style="width: 100%;">
      <app-roi-page [roiData]="roiData" [taxYear]="yearFilter" [showStrategyLink]="currentView== 'Strategy'"
                    (triggerNavigateToStrategyOverview)="navigateToStrategyOverview($event)" [displayLogo]="displayLogo" [isCustomer]="isCustomer"></app-roi-page>
    </div>
    <div class="row" *ngIf="hasScenarioData && scenarios.length == 0">
      <div class="medium-12 columns" class="text-center">
        {{orgName}} is working on creating a Tax Plan for you. Once ready you will receive a notification.
      </div>
    </div>
  </div>
</div>
